export function getForYouConfig() {
	return {
		forYouUrl: '/for-you',
		useRecentItems: () => [],
		viewAllRecentsUrl: '/recents',
		useStarredItems() {
			return [];
		},
		viewAllStarredUrl: '/starred',
	};
}
